import { isBrowserIE11 } from './lister-utilities';

export const getCookieExperiments = () => {
	const listerExperiments = document.cookie
		?.split(';')
		?.filter(
			(cookie) =>
				!cookie.includes('ABC') && cookie.includes('WEBSITE_EXPERIMENT_LISTER')
		);

	const listerABCExperiments = document.cookie
		?.split(';')
		?.filter(
			(cookie) =>
				cookie.includes('ABC') && cookie.includes('WEBSITE_EXPERIMENT_LISTER')
		);

	/*
    If any experiments have been set up for lister, this will map over them and remove the WEBSITE_EXPERIMENT_LISTER_
    to give us the key of e.g. CustomCategoriesEnabled, currently just returns true of fale based on if it is the control or not.
    */

	// Block all experiments on IE11
	const isIE11 = isBrowserIE11();

	const experimentStatesWithoutABC = listerExperiments?.reduce(
		(acc, experiment) => {
			const [key, value] = experiment
				?.replace('WEBSITE_EXPERIMENT_LISTER_', '')
				?.split('=');
			return { ...acc, [key.trim()]: isIE11 ? false : value !== 'Control' };
		},
		{}
	);

	const experimentStatesWithABC = listerABCExperiments?.reduce(
		(acc, experiment) => {
			const [key, value] = experiment
				?.replace('WEBSITE_EXPERIMENT_LISTER_ABC_', '')
				?.split('=');
			return { ...acc, [key.trim()]: isIE11 ? false : value };
		},
		{}
	);

	const experimentStates = {
		...experimentStatesWithoutABC,
		...experimentStatesWithABC		
	};

	return experimentStates ?? {};
};
